<template>
  <footer>
    <div class="box e-flex container">
      <div class="e-flex flex-column">
        <h1 class="fw-6 mt-4 mb-4" style="color: #fff">办保函, 就在这里</h1>

        <span class="fs-xs mt-4 mb-4 text-grey-1 footer-text">
          <a class="fw-6 fs-xs text-grey-1">服务电话：400-616-6620转3</a>
          <el-divider direction="vertical"></el-divider>
          <el-link class="fw-6 fs-xs text-grey-1" style="margin-bottom: 3px;" type="warning"
            @click="openScoreDialog()">意见反馈</el-link>
          <span v-if="!isCqsw && !isBsgzw">
            <el-divider direction="vertical">
            </el-divider>
            <el-link class="fw-6 fs-xs text-grey-1" style="margin-bottom: 3px;" type="warning"
              href="/#/aboutUs">关于我们</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link class="fw-6 fs-xs text-grey-1" style="margin-bottom: 3px;" type="warning"
            @click="openGuaranteeRefundDialog()">保函退款情形</el-link>
          </span>
        </span>


      </div>
      <div class="e-flex flex-column text-right">
        <span v-if="!isBsgzw" class="fs-xs mt-4 mb-4 text-grey-3">版权信息：2014-{{
          new Date().getFullYear()
          }}
          上海汇招信息技术有限公司版权所有 沪ICP备12042911号-3</span>
          <span v-if="isBsgzw" class="fs-xs mt-4 mb-4 text-grey-3">版权信息：2026
          保山市数字发展有限公司版权所有 滇ICP备2025052565号-6</span>
        <span class="fs-xs mt-4 mb-4 text-grey-1 footer-text">友情链接：<span v-if="!isCqsw && !isBsgzw"><a
              href="https://www.ebidding.com.cn/" target="_blank">上海汇招信息技术有限公司（易招标）</a>、<a
              href="https://www.zcjb.com.cn/" target="_blank">招采进宝（统一门户)</a><a href="http://www.qlebid.com/"
              target="_blank">、齐鲁采购与招标网</a>
          </span>
          <span v-if="isCqsw">
            <a href="https://ebs.cqswjt.cn/" target="_blank">重庆水务环境集团招标采购信息系统平台</a>
          </span>
          <span v-if="isBsgzw">
            <a href="https://bsgzw.zcjb.com.cn/" target="_blank">保山市国资阳光招采平台</a>
          </span>
        </span>
      </div>
      <ScoreDialog ref="scoreDialog" />
      <GuaranteeRefundDialog ref="guaranteeRefundDialog" />
    </div>
  </footer>
</template>
<script>
import ScoreDialog from "./ScoreDialog.vue"
import GuaranteeRefundDialog from "./GuaranteeRefundDialog.vue"
export default {
    components: {
    ScoreDialog,
    GuaranteeRefundDialog
  },
  computed: {
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
  },
   methods: {
    openScoreDialog(){
    this.$refs.scoreDialog.open()
    },
    openGuaranteeRefundDialog(){
    this.$refs.guaranteeRefundDialog.open()
    }
   }
}
</script>

<style scoped>
footer {
  min-width: 1200px;
  width: 100%;
  height: 200px;
  background: #404852;
}
.footer-text a {
  color: #cccccc;
}
.box {
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
</style>
